import { GanttTask } from '../types/gantt.types'
import { useSignalLayer } from './useSignalLayer'
import { SignalTaskContext, isoDay, slotItem } from '../constants/signalView'
import { PartnerCardSignal } from '../components/PartnerCard'
// 신호 문구용 공종 값 · 상세창 반장 신호 — 이동 전 GanttView.tsx 본문을 그대로 옮긴 것이다.
// 신호 팝오버 · 오늘 할일 패널의 처리 버튼은 서버 주소로 처리한다(useSignalAction).

export type UseGanttSignalBridgeArgs = {
  tasks: GanttTask[]
  orderMetaRef: React.MutableRefObject<Map<number, { vendorId: number | null; vendorName: string; }>>
  signal: ReturnType<typeof useSignalLayer>
}

export function useGanttSignalBridge({ tasks, orderMetaRef, signal }: UseGanttSignalBridgeArgs) {
  // 신호 문구 조립에 쓰는 공종 값(착공·종료일·반장 이름·순위·거래처)
  const signalTaskCtx = (taskId: number): SignalTaskContext => {
    const t = tasks.find(x => x.taskId === taskId)
    if (!t) return {}
    return {
      startDate: isoDay(t.startDate),
      endDate: isoDay(t.endDate),
      partnerName: t.foremanName,
      rank: t.confirmRequest?.rank ?? null,
      vendorName: orderMetaRef.current.get(taskId)?.vendorName || null,
    }
  }

  // 상세창 시공파트너 카드 점·사유 — 서버 반장 신호만 쓴다(조회 오류면 오류 표시, 이 공종 신호가 없으면 점 없음 — 폴백 없음)
  const panelForemanSignal = (t: GanttTask | null): PartnerCardSignal => {
    if (!t) return { state: 'loading' }
    if (signal.signalsQ.isError) return { state: 'error' }
    if (signal.signalsQ.isLoading) return { state: 'loading' }
    const item = slotItem(signal.byTask.get(t.taskId), 'FOREMAN')
    return item ? { state: 'ok', item, taskCtx: signalTaskCtx(t.taskId) } : { state: 'none' }
  }

  return { panelForemanSignal, signalTaskCtx }
}
